var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1623_1310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2335 3.95104C18.0236 3.17056 17.4082 2.55531 16.6278 2.34515C15.2022 1.95508 9.49954 1.95508 9.49954 1.95508C9.49954 1.95508 3.7971 1.95508 2.37146 2.33036C1.6061 2.5403 0.975736 3.17067 0.765799 3.95104C0.390625 5.37657 0.390625 8.33292 0.390625 8.33292C0.390625 8.33292 0.390625 11.3042 0.765799 12.7148C0.975959 13.4952 1.59109 14.1104 2.37157 14.3206C3.81211 14.7108 9.49977 14.7108 9.49977 14.7108C9.49977 14.7108 15.2022 14.7108 16.6278 14.3355C17.4083 14.1254 18.0236 13.5102 18.2337 12.7298C18.6088 11.3042 18.6088 8.34793 18.6088 8.34793C18.6088 8.34793 18.6238 5.37657 18.2335 3.95104ZM7.68394 11.0641V5.60174L12.426 8.33292L7.68394 11.0641Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1623_1310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4328,
    height: 19.4328,
    fill: "white",
    transform: "translate(0.390625 0.566406)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.618b8fab725edaab03cf43b51fcf777b.svg";
export { ForwardRef as ReactComponent };